import templateStr from 'text!./templates/ho-confirmation.html';

export default [function () {
    return {
        restrict: 'A',
        template: templateStr,
        controller: ['$scope', function ($scope) {
            this._coverages = function (coverages) {
                return coverages.map(function (cov) {
                    return {
                        name: cov.description,
                        amount: cov.amount,
                        terms: cov.terms
                    };
                });
            };

            $scope.baseCoverages = this._coverages($scope.chosenQuote.lobs.homeowners.baseCoverages);
            $scope.additionalCoverages = this._coverages($scope.chosenQuote.lobs.homeowners.additionalCoverages);
            $scope.basePremium = $scope.chosenQuote.lobs.homeowners.basePremium;
            $scope.schedules = $scope.chosenQuote.lobs.homeowners.schedules;
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/quoteandbind/ho/directives/HOConfirmation.js
// module id = 2153
// module chunks = 0